import { z } from 'zod';

export const CreateSalesReturnFormItemSchema = z.object({
    itemId: z.string(),
    itemName: z.string(),
    quantity: z.coerce.number(),
    returnQuantity: z.coerce.number(),
    price: z.coerce.number(),
    isSelected: z.boolean(),
});

export type CreateSalesReturnFormItem = z.infer<
    typeof CreateSalesReturnFormItemSchema
>;

export const CreateSalesReturnFormSchema = z.object({
    items: z.array(CreateSalesReturnFormItemSchema),
    reason: z.string().min(1, 'Reason is required'),
});

export type CreateSalesReturnForm = z.infer<typeof CreateSalesReturnFormSchema>;
